import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "@phosphor-icons/react";
import { Link } from "react-router-dom";

const ServiceCard = ({
  index,
  number,
  title,
  description,
  Icon,
  image,
  to = "/services",
  className = "",
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{
        duration: 0.6,
        delay: (index || 0) * 0.06,
        ease: [0.2, 0.7, 0.2, 1],
      }}
      className={`group relative overflow-hidden border border-border bg-card hover:border-primary transition-all duration-500 hover:-translate-y-1 ${className}`}
      data-testid={`service-card-${(title || "").toLowerCase().replace(/\s+/g, "-")}`}
    >
      {image && (
        <div className="relative h-44 md:h-56 overflow-hidden">
          <img
            src={image}
            alt={title}
            loading="lazy"
            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-card via-card/30 to-transparent" />
          {Icon && (
            <span className="absolute top-4 left-4 grid place-items-center w-11 h-11 rounded-sm bg-primary text-primary-foreground">
              <Icon size={20} weight="bold" />
            </span>
          )}
        </div>
      )}

      <div className="p-6 md:p-8">
        {number && (
          <div className="font-mono text-xs text-muted-foreground mb-3">
            {number}
          </div>
        )}
        <h3 className="font-display font-bold text-xl md:text-2xl tracking-tight mb-3 group-hover:text-primary transition-colors">
          {title}
        </h3>
        <p className="text-sm md:text-base text-muted-foreground leading-relaxed">
          {description}
        </p>

        <Link
          to={to}
          className="mt-6 inline-flex items-center gap-2 text-sm font-medium text-foreground group-hover:text-primary transition-colors"
        >
          <span className="uppercase tracking-[0.18em]">Read more</span>
          <ArrowUpRight
            size={16}
            weight="bold"
            className="transition-transform group-hover:translate-x-1 group-hover:-translate-y-1"
          />
        </Link>
      </div>
    </motion.div>
  );
};

export default ServiceCard;
